const CongestionModule =  {
    name: "Congestion",
    mapLayerIcon: "/mapicons/congestion.png",
    defaultOn: true,
    showOnMap: true,
    wmsMapLayer: "cdot:congestionsegments",
    wmsPublish: "tasWebapp.congestion.segments.publishing",
    congestionLayer:true
}

export default CongestionModule;
